@if (showSideMenu()) {
  <app-side-menu class="fixed h-screen w-[175px] top-0 md:w-auto md:z-[51] md:shadow-default" />
}
<div class="flex flex-col w-full overflow-x-hidden sm:ml-0" [ngClass]="{ 'ml-[175px] md:ml-[56px]': showSideMenu() }">
  <router-outlet />
</div>
@if (versions(); as versions) {
  <app-versions [versions]="versions" [showOnlyFeVersion]="showOnlyFeVersion" />
}
